import { __awaiter, __generator } from "tslib";
import { request } from "../../api/request";
import { GLOBAL_CONSTANTS } from "../../constants";
var progressFnSignature = function (ev) {
    console.log(ev);
};
export function performFileUpload(data, options) {
    return __awaiter(this, void 0, void 0, function () {
        var file, onProgress, body, _a, key, url;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    file = data.file;
                    onProgress = (options || {}).onProgress;
                    body = { contentType: file.type, name: file.name };
                    return [4, uploadGetKeyUrl(body)];
                case 1:
                    _a = _b.sent(), key = _a.key, url = _a.url;
                    return [4, uploadToS3(url, file, onProgress || (function () { return true; }))];
                case 2:
                    _b.sent();
                    return [2, { key: key, url: url }];
            }
        });
    });
}
export function getVideoDuration(data, callback) {
    var video = document.createElement("video");
    video.preload = "metadata";
    video.onloadedmetadata = function () {
        if (callback) {
            window.URL.revokeObjectURL(video.src);
            callback(video.duration);
        }
    };
    video.src = URL.createObjectURL(data.file);
}
export var uploadGetKeyUrl = function (body) {
    return request(GLOBAL_CONSTANTS.UPLOAD_URL, "POST", body);
};
export var uploadToS3 = function (url, data, onProgress) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open("PUT", url);
        xhr.setRequestHeader("Content-Type", data.type);
        if (onProgress) {
            xhr.upload.addEventListener("progress", onProgress);
        }
        xhr.addEventListener("load", function () {
            resolve();
        });
        xhr.addEventListener("error", function (err) {
            reject(err);
        });
        xhr.send(data);
    });
};
//# sourceMappingURL=uploaders.js.map